export default __webpack_public_path__ + "static/GLECB-a160cbca832b45b9b2b97255e9a32b4c.woff";